
<template>
	<page>
		<module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage">
            <template #search>
					<m-search ref="search">
						<m-search-item label="还款单号">
							<c-input name="record_no" placeholder="销售单号"></c-input>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_id" async @search="searchCustomer"></c-select>
						</m-search-item>
                        <m-search-item label="审批状态">
                            <c-select name="state" :options="AUDIT_STATE"></c-select>
                        </m-search-item>
						<m-search-item label="创建人">
							<c-select name="create_user_id" async @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
                        <m-search-item label="审批人">
                            <c-select name="audit_user_id" async @search="searchUser"></c-select>
                        </m-search-item>
						<m-search-item label="审批时间" colspan="2">
							<c-datetime range start-name="audit_start_date" end-name="audit_end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #repayment_amount="{data}">
					{{formatPrice(data.repayment_amount)}}
				</template>

                <!--账单状态-->
				<template #state="{data}">
                    <c-state async dict="AUDIT_STATE" tag :value="data.state"></c-state>
                </template>
                <!--还款凭证-->
				<template #voucher_img_url="{data}">
                    <c-file v-if="data.voucher_img_url" :src="data.voucher_img_url"></c-file>
                    <span v-else>-</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="150"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="creditRepaymentDetail(data)">详情</c-table-button>
                        <c-table-button v-if="auth('b_credit_repayment_audit')" icon="tf-approve" @click="creditRepaymentDetail(data)" :disabled="data.state != 1">审核</c-table-button>
                    </template>
                </c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
    import {asyncMapState} from '@/store'

    export default {
		data() {
            return {
                workType: 123,
                orderIds: [],
                repayment_amount:0,
                customer_id:0
            }
		},
        computed: {
            // 获取dictName选项数据
            ...mapState(['saasInfo']),
            ...asyncMapState(['AUDIT_STATE'])
        },
		methods: {
			/*********搜索客户**********/
			searchCustomer(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},
            /************搜索用户*******************************/
            searchUser(keyword, resolve) {
                let paramData = {
                    user_type: 1,
                    options_code: 'SYSUSER',
                    keyword: keyword
                };
                this.request({
                    url: '/system/options',
                    data: paramData,
                    success: data => {
                        resolve(data);
                    }
                })
            },
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},
            //打开详情页
            creditRepaymentDetail(data){//打开模板选择弹窗
                this.globalDialog('creditRepaymentDetail', {
                    props: {
                        id: data.id
                    }
                }, this.$refs.view.update);
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}
</style>
